import { Theme } from "./theme";

export { Theme };
